/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'cross': {
    width: 30,
    height: 30,
    viewBox: '0 0 30 30',
    data: '<g _fill="none" fill-rule="evenodd"><circle pid="0" _fill="#90A4AE" cx="15.5" cy="15.5" r="12.5"/><path pid="1" d="M4.353 4.42C7.299 1.473 10.848 0 15 0s7.69 1.462 10.614 4.386C28.538 7.31 30 10.848 30 15c0 4.152-1.462 7.69-4.386 10.614C22.69 28.538 19.152 30 15 30c-4.152 0-7.69-1.462-10.614-4.386C1.462 22.69 0 19.152 0 15c0-4.152 1.45-7.679 4.353-10.58zM21.73 19.568L16.686 14.5l5.112-5.068c.27-.27.27-.54 0-.81l-1.48-1.42C20.184 7.069 20.05 7 19.915 7c-.09 0-.202.068-.337.203l-5.112 5-5.112-5C9.22 7.068 9.108 7 9.018 7c-.135 0-.27.068-.404.203L7.202 8.622c-.27.27-.27.54 0 .81l5.112 5.068-5.112 5.135c-.09.045-.135.158-.135.338 0 .18.045.315.135.405l1.412 1.487c.09.09.225.135.404.135.18 0 .314-.045.404-.135l5.044-5.135 5.112 5.067c.135.135.247.203.337.203.134 0 .269-.068.403-.203l1.413-1.419a.455.455 0 0 0 .202-.405c0-.135-.068-.27-.202-.405z" _fill="#FBFAFD"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/cross.js